/* eslint-disable import/prefer-default-export */
import { object, string, ref } from "yup";

export const validationSchema = object().shape({
  password: string()
    .min(8, "Please enter at least ${min} characters")
    .matches(/[a-z]/, "Password must include at least one lowercase letter")
    .matches(/[A-Z]/, "Password must include at least one uppercase letter")
    .matches(/[0-9]/, "Password must include at least one number")
    .matches(/[\^$*.\[\]{}()?|+"!@#%&/\\,><':;=_~-]/, "Password must include at least one special character")
    .required("Password is a required"),
  confirmPassword: string()
    .oneOf([ref("password"), null], "Passwords do not match")
    .required("Confirm Password is required")
});
